import { render } from "./chat_list.vue?vue&type=template&id=78089bff"
import script from "./chat_list.js?vue&type=script&lang=js"
export * from "./chat_list.js?vue&type=script&lang=js"

import "./chat_list.vue?vue&type=style&index=0&id=78089bff&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__